const ScheduleData = [
    {
    id: 1,
    question:"Rahul has keen interest in the study of the virus and its handling. Which of the following branch of science can be related to his interest?",
    option1:'Bacteriology',
    option2:'Virology',
    option3:'Cytology',
    option4:'None of above',
    attempted:null,
   },
    {
    id: 2,
    question:"Rahul has keen interest in the study of the virus and its handling. Which of the following branch of science can be related to his interest?",
    option1:'Bacteriology',
    option2:'Virology',
    option3:'Cytology',
    option4:'None of above',
    attempted:null,
   },
   {
    id: 3,
    question:"Rahul has keen interest in the study of the virus and its handling. Which of the following branch of science can be related to his interest?",
    option1:'Bacteriology',
    option2:'Virology',
    option3:'Cytology',
    option4:'None of above',
    attempted:null,
   },
   {
    id: 4,
    question:"Rahul has keen interest in the study of the virus and its handling. Which of the following branch of science can be related to his interest?",
    option1:'Bacteriology',
    option2:'Virology',
    option3:'Cytology',
    option4:'None of above',
    attempted:null,
   }
]
export default ScheduleData;
